// Contact.js
import React from "react";
import VehicleLocationForm from './booking/VehicleLocationForm';




const Contact = () => {
  return (
    <div>
      <h2>Contact Page</h2>

      <VehicleLocationForm/>


      
    </div>
  );
};

export default Contact;
